import React from 'react'
import { Button, Box, Text, useDisclosure } from '@chakra-ui/react'

import ActionConfirmation from '~components/shared/modals/action-confirmation'
import { useActionItems } from '~contexts/action-item-provider'
import {
    ActionItemStatus,
    namedOperations,
    useUpdateActionItemMutation,
} from '~graphql/generated/graphql'

interface Props {
    actionItemId: string
    isSmall?: boolean
    onCompleted?: () => void
}

export default function FormMarkCompleteAction({
    actionItemId,
    isSmall = false,
    onCompleted,
}: Props) {
    const { refetch } = useActionItems()
    const { isOpen, onOpen, onClose } = useDisclosure()

    const [updateActionItem, { loading }] = useUpdateActionItemMutation({
        variables: {
            id: actionItemId,
            data: {
                status: ActionItemStatus.Completed,
            },
        },
        refetchQueries: [
            namedOperations.Query.countActionItems,
            namedOperations.Query.queryActionItems,
        ],
        onCompleted: () => {
            refetch()
            onCompleted?.()
        },
        awaitRefetchQueries: true,
    })

    return (
        <>
            <Button
                size={isSmall ? 'xs' : 'sm'}
                colorScheme="brand"
                shadow="sm"
                onClick={onOpen}
            >
                Mark as complete
            </Button>
            <ActionConfirmation
                isOpen={isOpen}
                onClose={onClose}
                onConfirm={async () => {
                    await updateActionItem()
                }}
                isLoading={loading}
                title="Mark form as complete?"
                size="xl"
            >
                <Box>
                    <Text fontWeight="semibold" mb={1}>
                        Are you sure you want to mark this form as complete?
                    </Text>
                    <Text fontSize="sm">
                        This removes it from your pending action list. You can
                        still view this form response on the Forms page at any
                        time.
                    </Text>
                </Box>
            </ActionConfirmation>
        </>
    )
}
